import { api } from '@services';

interface IResponse {
  equipments: number | null;
  manufacturers: number | null;
  skus: number | null;
}

const getStudioNumbers = async (id: string): Promise<IResponse> => {
  const { data: numbers } = await api.get<IResponse>(`/studios/${id}/numbers`);

  return numbers;
};

export { getStudioNumbers };
